import { render, staticRenderFns } from "./LicitacaoBuscaTabela.vue?vue&type=template&id=2ac27c78&scoped=true"
import script from "./LicitacaoBuscaTabela.vue?vue&type=script&lang=js"
export * from "./LicitacaoBuscaTabela.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoBuscaTabela.vue?vue&type=style&index=0&id=2ac27c78&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac27c78",
  null
  
)

export default component.exports